import { useCallback, useState } from "react";
import { func } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors, fonts } from "../../styles/Styles.variables";
import { routes } from "../../constants/routes";
import history from "../../helpers/history";

import Button from "../../styles/components/Button";
import Form from "../form";
import Group from "../form/components/Group";
import Label from "../form/components/Label";
import PageLogo from "../page/components/Page.logo";
import Text from "../form/components/Text";

function SignupFooter({ handleSignupFooterSubmit, trackEvent }) {
  const [email, setEmail] = useState("");

  const handleInput = useCallback(e => {
    setEmail(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      handleSignupFooterSubmit(email);
      if (trackEvent) {
        trackEvent({
          category: "Form",
          action: "Submit",
          label: "Weekly Used Equipment Email Sign-Up Footer",
        });
      }
      history.push(routes.emailSignup.path);
    },
    [email, handleSignupFooterSubmit, trackEvent]
  );

  return (
    <FormStyled onSubmit={handleSubmit} theme="light">
      <Brand>
        <Logo />
      </Brand>
      <Intro>
        Sign up for <strong>weekly deals!</strong>
      </Intro>
      <Group>
        <Label htmlFor="email" srOnly>
          Email
        </Label>
        <Text
          id="email-footer"
          maxLength="200"
          onChange={handleInput}
          placeholder="Email address"
          required
          size="small"
          type="email"
          value={email}
        />
      </Group>
      <ButtonStyled
        color="blue500"
        onClick={handleSubmit}
        size="small"
        type="submit"
      >
        Sign me up!
      </ButtonStyled>
    </FormStyled>
  );
}

const Brand = styled.div`
  margin-bottom: ${rem("16px")};
  max-width: 100%;
  width: ${rem("150px")};

  @media (min-width: ${rem("1240px")}) {
    width: ${rem("215px")};
  }
`;

const ButtonStyled = styled(Button)`
  font-size: ${rem("13px")};
  margin-top: ${rem("12px")};
  padding: ${rem("8px")} ${rem("22px")};
`;

const FormStyled = styled(Form)`
  align-items: center;
  background-color: ${colors.gray900};
  display: flex;
  flex-direction: column;
  padding: ${rem("58px")} ${rem("40px")} ${rem("30px")};

  @media (min-width: ${rem("1200px")}) {
    padding: ${rem("78px")} ${rem("60px")} ${rem("40px")};
  }
`;

const Intro = styled.p`
  color: ${colors.yellow};
  font-size: ${rem("16px")};
  line-height: 1;
  margin: 0 0 ${rem("16px")};
  text-align: center;
  text-transform: uppercase;
  text-wrap: balance;

  strong {
    font-weight: ${fonts.weights.bold};
  }
`;

const Logo = styled(PageLogo)`
  height: 0;
  overflow: hidden;
  max-width: 100%;
  padding-top: 11.336032389%;
  position: relative;

  svg {
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

SignupFooter.propTypes = {
  handleSignupFooterSubmit: func.isRequired,
  trackEvent: func,
};

export default SignupFooter;
